import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronLargeDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-large-down, chev down, down"} maskId="square-filled-radius-0-stroke-1-IconChevronLargeDown"><path fillRule="evenodd" clipRule="evenodd" d="M2.29045 8.82422L12 13.9345L21.7096 8.82422L22.1754 9.70914L12 15.0646L1.82471 9.70914L2.29045 8.82422Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronLargeDown;
